const numberToInt = (number) => {
    const pointPosition = number.toString().indexOf('.');
    if (-1 === pointPosition) {
        return { number, floatLength: 0 };
    }

    return { number: Number.parseInt(number.toString().replace('.', ''), 10), floatLength: number.toString().length - pointPosition - 1 };
};

const reverseIntConversion = (number, floatLength) => {
    let numStr = number.toString();
    const numLength = numStr.length;

    if (numStr.length < floatLength) {
        for (let i = 0; i < floatLength - numLength; i++) {
            numStr = `0${numStr}`;
        }

        return Number(`0.${numStr}`);
    }

    return Number(`${numStr.substring(0, numLength - floatLength)}.${numStr.substring(numLength - floatLength)}`);
};
const multiplication = (a, b) => {
    const aConversion = numberToInt(a);
    const bConversion = numberToInt(b);

    return reverseIntConversion(aConversion.number * bConversion.number, aConversion.floatLength + bConversion.floatLength);
};

const addition = (a, b) => {
    const aConversion = numberToInt(a);
    const bConversion = numberToInt(b);

    const maxFloatLength = aConversion.floatLength > bConversion.floatLength ? aConversion.floatLength : bConversion.floatLength;
    if (aConversion.floatLength > bConversion.floatLength) {
        bConversion.number *= (10 ** (aConversion.floatLength - bConversion.floatLength));
    } else if (aConversion.floatLength < bConversion.floatLength) {
        aConversion.number *= (10 ** (bConversion.floatLength - aConversion.floatLength));
    }

    return reverseIntConversion(aConversion.number + bConversion.number, maxFloatLength);
};

const roundNearest = (number, precision) => {
    const pointPosition = number.toString().indexOf('.');
    if (-1 === pointPosition) {
        return number;
    }

    if (Number(number.toString().substring(pointPosition + precision + 1, pointPosition + precision + 2)) >= 5) {
        const intConversion = numberToInt(number.toString().substring(0, pointPosition + precision + 1));

        return reverseIntConversion(intConversion.number + 1, intConversion.floatLength);
    }

    return Number(number.toString().substring(0, pointPosition + 1 + precision));
};

export { multiplication, addition, roundNearest, reverseIntConversion };



// WEBPACK FOOTER //
// ./src/utils/floatingMath.js